import React from 'react';
import { Routes as Switch } from 'react-router';
import { Route } from 'react-router-dom';
import { Carfoil } from '../../pages/Carfoil/Carfoil';
import { Carglass } from '../../pages/Carglass';
import { Contact } from '../../pages/Contact/Contact';
import { Home } from '../../pages/Home';
import { Impressum } from '../../pages/Impressum/Impressum';
import { Navigation } from '../../pages/Navigation/Navigation';

export const Routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/" element={<Home />} />
      <Route path="/autoglas" element={<Carglass />} />
      <Route path="/autofolie" element={<Carfoil />} />
      <Route path="/kontakt" element={<Contact />} />
      <Route path="/anfahrt" element={<Navigation />} />
      <Route path="/impressum" element={<Impressum />} />
    </Switch>
  );
};
